module.exports = __webpack_public_path__ + "static/media/weego-fb-logo@3x.9a0c73c1.png";